import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LoaderService, MessageService } from '@shared';
import { Tier, TiersService } from '@shared-data';

@Component({
  selector: 'app-unlock-tier',
  templateUrl: './unlock-tier.component.html',
  styleUrl: './unlock-tier.component.scss',
})
export class UnlockTierComponent {
  @Input()
  tierToUnlock!: Tier;

  @Output()
  onConfirm: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(
    private tierService: TiersService,
    private messageService: MessageService,
    private loaderService: LoaderService,
  ) {}

  onCancel() {
    this.onConfirm.emit(false);
  }

  onProceed() {
    this.loaderService.show();
    this.tierService.unlockTier(this.tierToUnlock.id).subscribe({
      next: () => {
        this.onConfirm.emit(true);

        this.loaderService.hide();
      },
      error: (err) => {
        const validationError = err?.error;
        if (validationError) {
          this.messageService.error(validationError);
        } else {
          this.messageService.error('Error unlocking tier');
        }
        this.tierToUnlock.isLocked = true;
        this.loaderService.hide();
        this.onConfirm.emit(false);
      },
    });
  }
}
